export const seriesColorsByUserId = {
  1: { '0_cVirtuell': '#ffffff', '0_DepotKursAktuell': '#38bdf8', '0_UfosDepotKursAktuell': '#f472b6' },
  7: { '0_cVirtuell': '#f8fafc', '0_DepotKursAktuell': '#818cf8' },
  5: { '0_cVirtuell': '#e2e8f0', '0_DepotKursAktuell': '#2dd4bf' },
};

export function getUserAvatarColor(value, userId) {
  const seriesKey = Number(userId) === 1 ? '0_UfosDepotKursAktuell' : '0_DepotKursAktuell';
  const analyzerColor = seriesColorsByUserId[Number(userId)]?.[seriesKey];
  if (analyzerColor) return analyzerColor;
  const colors = ['#1565c0', '#6a1b9a', '#00796b', '#ad1457', '#a84300', '#3949ab', '#546e7a'];
  let hash = 0;
  for (const character of String(value || '').trim().toLocaleLowerCase('de-DE')) {
    hash = (hash * 31 + character.codePointAt(0)) >>> 0;
  }
  return colors[hash % colors.length];
}
